/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createOcppRegistrationDeletionFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type OcppRegistrationDeletion, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/ocppconnection
 */
export interface OcppconnectionRequestBuilder extends BaseRequestBuilder<OcppconnectionRequestBuilder> {
    /**
     * DisconnectOcppCharger
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OcppRegistrationDeletion>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<OcppconnectionRequestBuilderDeleteQueryParameters> | undefined) : Promise<OcppRegistrationDeletion | undefined>;
    /**
     * DisconnectOcppCharger
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<OcppconnectionRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
}
/**
 * DisconnectOcppCharger
 */
export interface OcppconnectionRequestBuilderDeleteQueryParameters {
    deletePlugChoiceRegistration?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const OcppconnectionRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/ocppconnection{?deletePlugChoiceRegistration*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const OcppconnectionRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: OcppconnectionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOcppRegistrationDeletionFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
